import React, { createContext, useEffect, useState } from "react";
import { NamedProperty } from "sprint-common-web";

import { useCatalogueLookupsApi } from "../../api/catalogue-api/lookups/useCatalogueLookupsApi";

interface IVersionTypesDataContext {
    nonTrailerVersionTypes: VersionType[];
    trailerVersionTypes: VersionType[];
    isLoading: boolean;
}

export type VersionType = NamedProperty;

export const VersionTypesDataContext = createContext<IVersionTypesDataContext>({} as IVersionTypesDataContext);

type VersionTypesDataProviderProps = React.PropsWithChildren<unknown>;

export const VersionTypesDataProvider: React.FunctionComponent<VersionTypesDataProviderProps> = ({
    children
}: VersionTypesDataProviderProps) => {
    const [nonTrailerVersionTypes, setNonTrailerVersionTypes] = useState<VersionType[]>([]);
    const [trailerVersionTypes, setTrailerVersionTypes] = useState<VersionType[]>([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getNonTrailerVersionTypes, getTrailerVersionTypes } = useCatalogueLookupsApi();

    useEffect(() => {
        const loadVersionTypes = async () => {
            setIsLoading(true);

            try {
                const [nonTrailer, trailer] = await Promise.all([
                    getNonTrailerVersionTypes(),
                    getTrailerVersionTypes()
                ]);

                setNonTrailerVersionTypes(sortVersionTypesByName(nonTrailer.versions));
                setTrailerVersionTypes(sortVersionTypesByName(trailer.versions));
            } finally {
                setIsLoading(false);
            }
        };

        loadVersionTypes();
    }, []);

    return (
        <VersionTypesDataContext.Provider value={{ nonTrailerVersionTypes, trailerVersionTypes, isLoading }}>
            {children}
        </VersionTypesDataContext.Provider>
    );
};

const sortVersionTypesByName = (listToSort: NamedProperty[]): NamedProperty[] => {
    return listToSort.sort((prev, next) => (prev.name !== next.name ? (prev.name < next.name ? -1 : 1) : 0));
};
